module.exports = __webpack_public_path__ + "static/img/005.7350845.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/005.png
// module id = 3ltW
// module chunks = 1